<template>
    <div class="list-container">
        <h2>Manage Employees</h2>
        <button class="btn btn-sm add-btn" @click="$router.push('/dashboard/employees/add')">Add Employee</button>

        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>

        <ul v-else class="data-list">
            <li v-for="employee in employees" :key="employee.id" class="list-item"
                :class="{ 'bg-disabled': !employee.user.is_active }">
                <div class="item-info">
                    <span class="info-item"><strong>Name:</strong> {{ employee.user.name }}</span>
                    <span class="info-item"><strong>Email:</strong> {{ employee.user.email }}</span>
                    <span class="info-item"><strong>Department:</strong> {{ employee.department || 'N/A' }}</span>
                    <span class="info-item"><strong>Active:</strong> {{ employee.user.is_active ? 'Yes' : 'No' }}</span>
                </div>
                <div class="btn-group">
                    <button class="btn btn-sm edit-btn"
                        @click="$router.push(`/dashboard/employees/edit/${employee.id}`)">✏️ Edit</button>
                    <button class="btn btn-sm delete-btn" @click="toggleEmployeeStatus(employee.id)"
                        v-if="employee.user.is_active">Disable</button>
                    <button class="btn btn-sm" @click="toggleEmployeeStatus(employee.id)" v-else>
                        Enable</button>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            employees: [],
            loading: false
        };
    },
    methods: {
        async fetchEmployees() {
            this.loading = true;
            try {
                const response = await this.$api.get('/employees');
                this.employees = response.data;
            } catch (error) {
                console.error("Error fetching employees:", error);
            }
            this.loading = false;
        },
        async toggleEmployeeStatus(id) {
            if (!confirm("Are you sure you want to change this employee's status?")) return;
            try {
                let employee = this.employees.find(emp => emp.id == id);
                await this.$api.patch(`/employees/${id}/toggle`);
                employee.user.is_active = !employee.user.is_active;
            } catch (error) {
                console.error("Error toggling employee status:", error);
            }
        }
    },
    mounted() {
        this.fetchEmployees();
    }
};
</script>

<style scoped>
.list-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.7);
}

.spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid #1Dbcbc;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
